const DEFAULT_VISIBILITY_OFFSET = 20;
/**
 * Check if an HTML element or a reference to an element is in screen.
 * @param element Expects either React.MutableRefObject or an HTMLElement type
 * @param offset
 * @returns true if the element is visible on the screen, false otherwise.
 */
export const isVisible = (element: any, offset?: number) => {
  let top = 0;
  // heuristic: if element has getBoundingClientRect method, then it is an HTML element
  if (typeof element.getBoundingClientRect === "function") {
    top = element.getBoundingClientRect().top;
  } else {
    if (!element.current) {
      return;
    }
    // otherwise, treat as React reference
    top = element?.current?.getBoundingClientRect().top || 0;
  }
  offset = offset ?? DEFAULT_VISIBILITY_OFFSET;
  return top + offset >= 0 && top - offset <= window.innerHeight;
};

export const scrollToSubStepElement = (
  node: HTMLDivElement,
  searchParams: { subStep: string; noScroll: boolean },
  subStep: string,
) => {
  if (searchParams.subStep === subStep && !searchParams.noScroll) {
    node.scrollIntoView({ block: "start", behavior: "smooth" });
  }
};
